import * as groups from '@wix/auto_sdk_groups_groups';
import * as members from '@wix/auto_sdk_groups_members';
import * as groupRequests from '@wix/auto_sdk_groups_group-requests';
import * as roles from '@wix/auto_sdk_groups_roles';
import * as rules from '@wix/auto_sdk_groups_rules';
import * as joinGroupRequests from '@wix/auto_sdk_groups_join-group-requests';
import * as membershipQuestions from '@wix/auto_sdk_groups_membership-questions';

export {
  groups,
  members,
  groupRequests,
  roles,
  rules,
  joinGroupRequests,
  membershipQuestions,
};
